/**
 * CZNA-1449 — what the "Přidat podpole…" combobox of one field instance offers,
 * in which order, and what a typed query leaves of it.
 *
 * <p>Two sources, one list: first the optional subfields the template declares
 * and the form does not draw yet (`defaultVisible: false`), then — under a
 * separator — the subfields the MARC catalog allows and the template does not
 * declare (`addableSubfields`, CZNA-1410). For the cataloguer both are "a
 * subfield this field can still take"; whether the template knows it is ours.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * `template` then `catalog`, each in its own order, narrowed to what matches
 * `query`. One character, or anything after `$`, is a code — a cataloguer who
 * types `b` means `$b`, not every name with a "b" in it; anything longer also
 * matches a part of the name. A code the template offers is not offered again
 * from the catalog.
 */
export var subfieldSuggestions = function (template, catalog, query) {
    if (query === void 0) { query = ''; }
    var fromTemplate = new Set(template.map(function (s) { return s.code; }));
    var all = __spreadArray(__spreadArray([], template.map(function (s) { return (__assign(__assign({}, s), { source: 'template' })); }), true), catalog.filter(function (s) { return !fromTemplate.has(s.code); }).map(function (s) { return (__assign(__assign({}, s), { source: 'catalog' })); }), true);
    var typed = query.trim();
    var q = typed.replace(/^\$/, '').toLowerCase();
    if (!q)
        return all;
    var codeOnly = typed.startsWith('$') || q.length === 1;
    return all.filter(function (s) { return s.code.toLowerCase() === q || (!codeOnly && s.label.toLowerCase().includes(q)); });
};
/**
 * The suggestion the combobox makes active for `query`: the one whose code is
 * exactly what was typed — `b` then Enter means `$b`, not the first name with a
 * "b" in it — else the first.
 */
export var preferredSuggestion = function (suggestions, query) {
    var q = query.trim().replace(/^\$/, '').toLowerCase();
    var exact = q ? suggestions.findIndex(function (s) { return s.code.toLowerCase() === q; }) : -1;
    return exact >= 0 ? exact : 0;
};
